import React from 'react';
import { Grid } from '@mui/material';
import { GridLeft, GridRight, GridSection } from '../../../Episode.Styled';
import {
  CalOMSAdmitHeading,
  CalOMSAdmitSubHeading,
  CheckboxGridItems,
  ClientDetails,
  InputFieldGridItems,
  getCheckboxItems,
} from '../AuthTabCommonUtils';
import {
  clientDischargeLeftDetails as left,
  clientDischargeRightDetails as right,
  dischargeStatus,
  primaryAlcoholProblem,
  drugUsedDays,
  routeOfAdministration,
  secondaryAlcoholProblem,
} from '../authTabConstants';
import {
  dis2,
  adu1a,
  adu1b,
  adu2,
  adu3,
  adu4,
  adu5a,
  adu5b,
  adu6,
  adu7,
  adu8,
  adu9,
  adu10,
} from './CalOMSQuestionnaireConstants';
import { useSelector } from 'react-redux';
import { getValidDate } from '../../../../common/commonUtils/commonUtils';

const PageOneCalOMSDischarge = () => {
  const getCalOMSAdmitPdfForm = useSelector(
    (state) => state?.CalOMSDischargeForm?.data
  );

  const {
    cboID = '',
    cdSapAthID = '',
    sapAthDchDate,
    cdDchSts,
    cdPriDrugName = '',
    cdPriDrugUse,
    cdPriDrugAge = '',
    cdSecDrugName = '',
    cdSecDrugUse,
    cdSecDrugAge = '',
    cdNeedles,
    cdPriDrug,
    cdSecDrug,
    cboName = '',
    prtKey = '',
    epdIcnCDC = '',
  } = getCalOMSAdmitPdfForm || {};

  const dischargeDate = getValidDate(sapAthDchDate);
  const leftDetails = left({ cboName, prtKey, epdIcnCDC });
  const rightDetails = right({
    cboID,
    cdSapAthID,
    dischargeDate,
  });

  return (
    <Grid container>
      <GridSection mt={1} mx={2} container spacing={1}>
        <CalOMSAdmitHeading title="Discharge Questionnaire" />
      </GridSection>

      <GridSection mt={1} mx={2} container spacing={1}>
        <Grid item container md={10} sm={6} xs={6}>
          <ClientDetails data={leftDetails} />
        </Grid>

        <Grid item container md={2} sm={6} xs={6}>
          <ClientDetails data={rightDetails} />
        </Grid>
      </GridSection>

      <GridSection mx={2} container spacing={1}>
        <GridLeft item container xs={6}>
          <CalOMSAdmitSubHeading title="Discharge Information" />

          <CheckboxGridItems
            heading="DIS-2"
            data={getCheckboxItems(dischargeStatus, cdDchSts)}
            text={dis2}
          />

          <CalOMSAdmitSubHeading title="Alcohol and Other Drug Use" />

          <CheckboxGridItems
            heading="ADU-1a"
            data={getCheckboxItems(primaryAlcoholProblem, cdPriDrug)}
            text={adu1a}
          />

          <InputFieldGridItems
            heading="ADU-1b"
            value={cdPriDrugName}
            text={adu1b}
          />

          <CheckboxGridItems
            heading="ADU-2"
            data={getCheckboxItems(drugUsedDays, cdPriDrugUse)}
            text={adu2}
          />

          <CheckboxGridItems
            heading="ADU-3"
            data={routeOfAdministration}
            text={adu3}
          />

          <InputFieldGridItems
            heading="ADU-4"
            value={cdPriDrugAge}
            text={adu4}
          />
        </GridLeft>

        <GridRight item container xs={6}>
          <CalOMSAdmitSubHeading title="Alcohol and Other Drug Use" />

          <CheckboxGridItems
            heading="ADU-5a"
            data={getCheckboxItems(secondaryAlcoholProblem, cdSecDrug)}
            text={adu5a}
          />

          <InputFieldGridItems
            heading="ADU-5b"
            value={cdSecDrugName}
            text={adu5b}
          />

          <CheckboxGridItems
            heading="ADU-6"
            data={getCheckboxItems(drugUsedDays, cdSecDrugUse)}
            text={adu6}
          />

          <CheckboxGridItems
            heading="ADU-7"
            data={routeOfAdministration}
            text={adu7}
          />

          <InputFieldGridItems
            heading="ADU-8"
            value={cdSecDrugAge}
            text={adu8}
          />

          <CheckboxGridItems heading="ADU-9" data={drugUsedDays} text={adu9} />

          <CheckboxGridItems
            heading="ADU-10"
            data={getCheckboxItems(drugUsedDays, cdNeedles)}
            text={adu10}
          />
        </GridRight>
      </GridSection>
    </Grid>
  );
};

export default PageOneCalOMSDischarge;
